module.exports = __webpack_public_path__ + "static/media/water-bottles.85e40b63.jpg";